import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import es from "@/i18n/ar.json";
import Logo from "@/components/Logo";

// Thank-you page is SPANISH-ONLY per spec, and lives at /thank_you.
export default function ThankYou() {
  useEffect(() => {
    document.documentElement.setAttribute("lang", "es");
    document.title = "¡Gracias! · Ronaviraxa";
  }, []);

  const ty = es.thankYou;

  return (
    <div className="min-h-screen flex flex-col bg-[color:var(--rv-bg)] text-[color:var(--rv-ink)]">
      <header className="header border-b border-[color:var(--rv-line)]">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 flex items-center">
          <Link to="/" className="flex items-center gap-3">
            <Logo className="h-9 w-9 rounded-lg" />
            <div className="leading-none">
              <div className="font-serif text-lg">Ronaviraxa</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-[color:var(--rv-muted)]">Real estate colaborativo</div>
            </div>
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-5 py-16 md:py-24">
        <div className="max-w-2xl w-full text-center">
          <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[color:var(--rv-accent)] text-[color:var(--rv-ink)] mb-6 font-serif text-2xl">✓</div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-[color:var(--rv-muted)] mb-3">{ty.eyebrow}</div>
          <h1 className="font-serif text-4xl md:text-5xl leading-tight tracking-tight">{ty.title}</h1>
          <p className="mt-6 text-lg text-[color:var(--rv-ink)]/85 leading-relaxed">{ty.text}</p>
          <p className="mt-3 text-base text-[color:var(--rv-muted)] leading-relaxed">{ty.text2}</p>
          <div className="mt-8">
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded-full bg-[color:var(--rv-ink)] text-[color:var(--rv-bg)] px-6 py-3 text-sm font-semibold"
              data-testid="thankyou-back"
            >
              {ty.back}
            </Link>
          </div>
          <p className="mt-10 text-sm text-[color:var(--rv-muted)]">— {ty.signature}</p>
        </div>
      </main>

      <footer className="border-t border-[color:var(--rv-line)] py-6">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 text-xs text-[color:var(--rv-muted)] text-center">
          © 2026 Ronaviraxa S.A.S. · Ciudad Autónoma de Buenos Aires, Argentina
        </div>
      </footer>
    </div>
  );
}
